import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormComponent } from './references/form/form.component';
import { SearchComponent } from './references/search/search.component';

const routes: Routes = [
  { path: '', redirectTo: '/references/search', pathMatch: 'full' },
  {
    path: 'references',
    children: [
      { path: 'form', component: FormComponent, pathMatch: 'full' },
      { path: 'form/:referenceId', component: FormComponent, pathMatch: 'full' },
      { path: 'search', component: SearchComponent, pathMatch: 'full' }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
